<template>
  <layout-main-inner title="收货方详情">
    <el-form :model="delivery"
      disabled=""
      label-position='top'>
      <layout-card-wrap hasHeaderSlot
        v-loading="loading">
        <template slot="title">基本信息</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收货方名称:">
              {{delivery.deliveryName}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话:">
              {{delivery.deliveryPhone}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收件省市(地区)区(县):">
              {{delivery.provinceName}}-{{delivery.cityName}}-{{delivery.areaName}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详细地址:">
              {{delivery.detailedAddress}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="销售区域(H5展示):">
              {{delivery.saleAreaName}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="销售区域:"
              prop="saleAreas">
              <!-- <checkbox-tree ref="area"
                :treeData="cityTree"
                nodeKey="areaCode"
                :defaultProps="defaultProps"
                v-model="delivery.saleAreas" /> -->
                <div v-for="(item, index) in delivery.saleAreas" :key="index">{{ item }}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </layout-card-wrap>
    </el-form>
    <template slot="footer">
      <back-button ref="back" />
      <el-button type="primary"
        @click="edit"
        :loading="loading">编辑</el-button>
    </template>
  </layout-main-inner>
</template>
<script>
// import CheckboxTree from '@/components/public/checkbox-tree.vue'
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
  name: 'delivery-create',
  components: { }, // CheckboxTree
  props: {},
  data () {
    return {
      loading: false,
      defaultProps: {
        children: 'children',
        label: 'areaName'
      },
      delivery: {
        area: [],
        saleAreas: []
      },
      cityTree: [],
      expandedkeys: []
    }
  },
  watch: {},
  computed: {
    ...mapState({
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    edit () {
      this.$router.push(`/delivery-edit?vendorId=${this.$route.query.vendorId}&deliveryAddressId=${this.$route.query.deliveryAddressId}`)
    },
    getdeliveryaddress () {
      this.$store.dispatch('delivery/getdeliveryaddress', {
        payload: {
          vendorId: this.$route.query.vendorId,
          deliveryAddressId: this.$route.query.deliveryAddressId
        },
        success: (res) => {
          this.delivery = {
            ...this.delivery,
            ...res.data,
            saleAreas: res.data.saleAreas.map(item => item.provinceName + '/' + item.cityName + (this.userDetail.saleAreaLevel === 2 ? '' : '/' + item.areaName))
          }
          // this.expandedkeys = res.data.saleAreas.map(item => item.provinceCode)
          // this.getcitytree()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getcitytree () {
      this.$store.dispatch('delivery/getcitytree', {
        payload: {},
        success: (res) => {
          res.data.areaNodes.forEach(i => {
            i.provinceCode = i.areaCode
            i.children.forEach(s => {
              s.provinceCode = i.areaCode
              s.cityCode = s.areaCode
            })
          })
          _.remove(res.data.areaNodes, i => this.expandedkeys.indexOf(i.areaCode) === -1)
          res.data.areaNodes.forEach(i => {
            if (this.delivery.saleAreas.indexOf(i.areaCode) === -1) {
              _.remove(i.children, s => this.delivery.saleAreas.indexOf(s.areaCode) === -1)
            }
          })
          this.cityTree = res.data.areaNodes
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  },
  created () { },
  mounted () {
    this.getdeliveryaddress()
  }
}
</script>
<style lang="stylus"></style>
